<div class="title">
    <div>Automatic cell type detection</div>
    <button class="wiki-btn" (click)="goToWiki()">?</button>
</div>
<form class="job-selection-dialog-content" (keyup.enter)="startJob()">
    <cds-form-group layout="vertical">
        <cds-select>
            <label>Organism</label>
            <select
                name="target-layer-selection"
                [ngModel]="selectedOrganism"
                (ngModelChange)="selectOrganism($event)"
            >
                <option [ngValue]="SegmentationTypeEnum.Human">Human</option>
                <option [ngValue]="SegmentationTypeEnum.Mouse">Mouse</option>
            </select>
        </cds-select>
        <app-multi-select-box
            [title]="'Marker'"
            [items]="imageLayers$ | async"
            (selected)="selectMarkerLayers($event)"
        ></app-multi-select-box>
        <app-multi-select-box
            [title]="'Transcript'"
            [items]="annotationLayers$ | async"
            (selected)="selectTranscriptLayers($event)"
        ></app-multi-select-box>
        <div *ngIf="siblingDatasets!.length > 1">
            <cds-checkbox>
                <label>Run the job on datasets in the same folder</label>
                <input
                    id="runBatchJob"
                    type="checkbox"
                    name="runBatchJob"
                    [(ngModel)]="runBatchJob"
                />
            </cds-checkbox>
            <ul class="batch-datasets" [class.show]="runBatchJob">
                <li *ngFor="let dataset of siblingDatasets">
                    {{ dataset }}
                </li>
            </ul>
        </div>
    </cds-form-group>
</form>
<div class="actions action-buttons">
    <cds-button size="sm" action="flat" (click)="cancel()">Cancel</cds-button>
    <cds-button size="sm" (click)="startJob()" [disabled]="!canStart">Start Job</cds-button>
</div>
